'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _extends = _interopDefault(require('babel-runtime/helpers/extends'));

var $config = {
	"plugin-instance-id-param-name": "__plugin_instance_id__",
	"plugin-params-change-event-name": "__plugin_params_change__",
	"plugin-height-change-event-name": "__plugin_height_change__"
};

var hash = location.hash.replace("#", "");
// 插件实例ID
var pluginInstanceId = function (item) {
    if (item) {
        return item.split("=")[1];
    }
}(((hash || location.search).split("?")[1] || "").split("&").find(function (item) {
    return item.split("=")[0] === $config["plugin-instance-id-param-name"];
}));

var initialState = window.__INITIAL_STATE__ || {};

// 插件配置信息
var config = _extends({}, initialState.pluginConfig || {}, function (config) {
    if (config) {
        try {
            return JSON.parse(config) || {};
        } catch (e) {}
    }

    return {};
}(pluginInstanceId ? sessionStorage.getItem(pluginInstanceId) : null));

var config$1 = {
    get config() {
        return config;
    },
    basePath: initialState.basePath || "/",
    pluginInstanceId: pluginInstanceId
};

var listeners = [];

window.addEventListener("message", function (_ref) {
    var e = _ref.data;

    if (e.type === $config["plugin-params-change-event-name"]) {
        listeners.forEach(function (listener) {
            return listener(e.data);
        });
    }
});

var event = {
    listen: function listen(listener) {
        listeners.push(listener);

        return function () {
            var index = listeners.indexOf(listener);
            listeners.splice(index, 1);
        };
    },
    emit: function emit(name, data) {
        if (config$1.pluginInstanceId) {
            window.parent.postMessage({
                pluginInstanceId: config$1.pluginInstanceId,
                name: name,
                data: data
            }, "*");
        }
    }
};

var HEIGHT_CHANGE_EVENT = $config["plugin-height-change-event-name"];

function updateHeight() {
    event.emit(HEIGHT_CHANGE_EVENT, document.documentElement.offsetHeight || document.documentElement.scrollHeight);
}
updateHeight();
window.addEventListener("load", updateHeight);

var index = {
    HEIGHT_CHANGE_EVENT: HEIGHT_CHANGE_EVENT,
    get config() {
        return config$1.config;
    },
    get basePath() {
        return config$1.basePath;
    },
    emit: function emit() {
        event.emit.apply(event, arguments);
    },
    listen: function listen(listener) {
        return event.listen(listener);
    }
};

module.exports = index;



//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_web-plugin@0.1.0-alpha.4@@bone/web-plugin/lib/index.js
// module id = 2551
// module chunks = 4